let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5FD4o")).then(() => parcelRequire('9XBkh'));